var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.item.pdf}},[_c('pdf',{ref:"pdf",attrs:{"src":_vm.item.pdf,"resize":true,"text":false}},[_c('template',{slot:"loading"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }